/**
 * Platform admin card: load and edit one school's AI policy override by
 * school ID (AIPolicyEditor in school mode).
 */
import React, { useState } from 'react';
import { TextInput } from 'react-native';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Text } from '@/components/ui/text';
import AIPolicyEditor from './AIPolicyEditor';

export default function SchoolAiPolicyOverrideCard() {
  const [schoolIdInput, setSchoolIdInput] = useState('');
  const [selectedSchoolId, setSelectedSchoolId] = useState<number | null>(null);

  return (
    <Card className="mb-4">
      <CardHeader>
        <Text className="font-semibold text-lg">School AI Policy Override</Text>
      </CardHeader>
      <CardContent>
        <TextInput
          value={schoolIdInput}
          onChangeText={setSchoolIdInput}
          placeholder="Enter school ID"
          keyboardType="numeric"
          className="border border-gray-300 rounded px-3 py-2 mb-2"
        />
        <Button onPress={() => setSelectedSchoolId(parseInt(schoolIdInput, 10))}>
          <Text className="text-white font-medium">Load School Policy</Text>
        </Button>
        {selectedSchoolId !== null && (
          <AIPolicyEditor
            mode="school"
            schoolId={selectedSchoolId}
            title={`School ${selectedSchoolId} AI Policy`}
          />
        )}
      </CardContent>
    </Card>
  );
}
